import React, { useEffect } from 'react';

import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';
import { CookieConsentConfig } from 'vanilla-cookieconsent';

import { useThemeMode } from 'contexts/ThemeContext';
import { ThemeMode } from 'types/enums';
import { LINKS } from 'components/constants';
import { useMatomo } from 'contexts/MatomoContext';

import './cookies-dialog.scss';

import cookieIcon from 'assets/img/cookie.svg';

export const CookiesDialog = () => {
  const { themeMode } = useThemeMode();
  const { updateConsent } = useMatomo();

  const description = () => (
    `
      <div class="cookies-description">
        <img src="${cookieIcon}" />
        We use cookies to analyze traffic and help improve your experience.
        <a href="${LINKS.privacyPolicy}" target="_blank">Privacy Policy</a>
      </div>
    `
  );

  const config: CookieConsentConfig = {
    categories: {
      matomo: {
        enabled: false,
      },
    },

    guiOptions: {
      consentModal: {
        layout: 'cloud inline',
        position: 'top center',
        flipButtons: true,
      },
    },

    language: {
      default: 'en',
      translations: {
        en: {
          consentModal: {
            title: '',
            description: description(),
            acceptAllBtn: 'Accept',
            acceptNecessaryBtn: 'Reject',
          },
          preferencesModal: {
            title: 'Manage cookie preferences',
            acceptAllBtn: 'Accept all',
            acceptNecessaryBtn: 'Reject all',
            savePreferencesBtn: 'Accept current selection',
            closeIconLabel: 'Close modal',
            sections: []
          }
        }
      }
    },

    onFirstConsent: ({cookie}) => {
      updateConsent(cookie?.categories?.length > 0);
    }
  };

  useEffect(() => {
    document.documentElement.classList.remove('cc--darkmode');
    if (themeMode === ThemeMode.DARK) {
      document.documentElement.classList.add('cc--darkmode');
    }
  }, [themeMode]);

  useEffect(() => {
    /**
     * All config. options available here:
     * https://cookieconsent.orestbida.com/reference/configuration-reference.html
     */
    CookieConsent.run(config);

    if (!CookieConsent.acceptedCategory('matomo')) {
      CookieConsent.reset(true);
      CookieConsent.run(config);
    }
  }, []);

  return null;
}
